module.exports = __webpack_public_path__ + "static/media/data.ce0208a4.png";